import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ca9bb59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-risk-dialog" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "公司", -1))
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "渠道", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-item info-item-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "应收合计", -1))
const _hoisted_16 = {
  key: 1,
  class: "dqys-empty"
}

import { computed, reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import type { TableColumnsType } from 'ant-design-vue';
import type { ReceivableManageItem } from './index';
import { saveReceivableManage } from './index';

interface DqysEntry {
  key: string;
  value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRiskDialog',
  props: {
    visible: { type: Boolean },
    record: null
  },
  emits: ["update:visible", "submitted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
  (e: 'submitted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableManageItem | null;
}





const riskLevelOptions = [
  { value: '高', label: '高' },
  { value: '中', label: '中' },
  { value: '低', label: '低' },
];

const prosecuteOptions = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

const submitting = ref(false);
const formRef = ref<FormInstance>();
const form = reactive({
  riskLevel: undefined as string | undefined,
  riskReason: '',
  riskDesc: '',
  /** 下拉用字符串，避免 a-select 对 false 处理异常 */
  isProsecute: undefined as string | undefined,
});

/** 对齐设计器：字段下方红字「必填」 */
const formRules: Record<string, Rule[]> = {
  riskLevel: [{ required: true, message: '必填', trigger: 'change' }],
  riskReason: [{ required: true, whitespace: true, message: '必填', trigger: 'blur' }],
  riskDesc: [{ required: true, whitespace: true, message: '必填', trigger: 'blur' }],
  isProsecute: [{ required: true, message: '必填', trigger: 'change' }],
};

const FIELD_LABELS: Record<string, string> = {
  riskLevel: '风险等级',
  riskReason: '风险等级原因',
  riskDesc: '逾期原因及说明',
  isProsecute: '是否起诉客户',
};

function parseIsProsecute(value?: string): string | undefined {
  if (value === '是') return 'true';
  if (value === '否') return 'false';
  return undefined;
}

function todayYmd() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function parseDqysEntries(raw?: string): DqysEntry[] {
  const text = (raw ?? '').trim();
  if (!text) return [];
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return [];
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return [];
  return Object.keys(parsed as Record<string, unknown>).map((key) => {
    const num = Number(String((parsed as Record<string, unknown>)[key]).replace(/,/g, ''));
    return { key, value: Number.isFinite(num) ? num : 0 };
  });
}

const dqysEntries = computed(() => parseDqysEntries(props.record?.dqysJson));

/** 金额统一保留两位小数（四舍五入） */
function round2(value: number): number {
  return Math.round((Number(value) || 0) * 100) / 100;
}

/** 应收合计：后端已冲抵后的各列求和 */
const totalAmount = computed(() =>
  round2(dqysEntries.value.reduce((sum, item) => sum + (Number(item.value) || 0), 0)),
);

/** 展示用各列：直接使用后端冲抵后的值，前端不再二次冲抵 */
const displayDqysValues = computed(() =>
  dqysEntries.value.map((item) => round2(Number(item.value) || 0)),
);

function formatMoney(value: number) {
  return round2(value).toFixed(2);
}

const DQYS_TOTAL_COL_WIDTH = 126;
const DQYS_DETAIL_COL_WIDTH = 160;

const dqysColumns = computed<TableColumnsType>(() => {
  const cols: TableColumnsType = [
    {
      title: '应收合计',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      width: DQYS_TOTAL_COL_WIDTH,
    },
  ];
  dqysEntries.value.forEach((item, index) => {
    cols.push({
      title: item.key,
      dataIndex: `col_${index}`,
      key: `col_${index}`,
      align: 'center',
      width: DQYS_DETAIL_COL_WIDTH,
    });
  });
  return cols;
});

const dqysDataSource = computed(() => {
  const row: Record<string, string> = {
    key: 'dqys-row',
    total: formatMoney(totalAmount.value),
  };
  displayDqysValues.value.forEach((value, index) => {
    row[`col_${index}`] = formatMoney(value);
  });
  return [row];
});

watch(
  () => props.visible,
  (open) => {
    if (!open) return;
    form.riskLevel = props.record?.riskLevel || undefined;
    // 仅高/中/低可选；其它值（如待人工确认）不预选，让用户重新选择
    if (form.riskLevel && !['高', '中', '低'].includes(form.riskLevel)) {
      form.riskLevel = undefined;
    }
    form.riskReason = props.record?.riskReason || '';
    form.riskDesc = props.record?.overdueReason || '';
    form.isProsecute = parseIsProsecute(props.record?.isProsecute);
    formRef.value?.clearValidate();
  },
);

function handleCancel() {
  emit('update:visible', false);
}

async function handleSave() {
  try {
    await formRef.value?.validate();
  } catch (err: unknown) {
    const errorFields = (err as { errorFields?: Array<{ name: Array<string | number> }> })
      ?.errorFields;
    const firstName = errorFields?.[0]?.name?.[0];
    const label = firstName != null ? FIELD_LABELS[String(firstName)] : '';
    message.error(label ? `${label} 必填` : '请完善必填信息');
    return Promise.reject();
  }

  const sapCustomerCode = (props.record?.customerCode || '').trim();
  const dissaleChannelCode = (props.record?.dissaleChannelCode || '').trim();
  if (!sapCustomerCode) {
    message.error('缺少客户编码，无法保存');
    return Promise.reject();
  }
  if (!dissaleChannelCode) {
    message.error('缺少渠道信息，无法保存');
    return Promise.reject();
  }

  submitting.value = true;
  try {
    await saveReceivableManage({
      dissaleChannelCode,
      sapCustomerCode,
      corpCode: (props.record?.corpCode || '').trim(),
      lDate: todayYmd(),
      riskLevel: form.riskLevel!,
      riskReason: (form.riskReason || '').trim(),
      riskDesc: (form.riskDesc || '').trim(),
      isProsecute: form.isProsecute === 'true',
    });
    message.success('保存成功');
    emit('update:visible', false);
    emit('submitted');
  } catch (error) {
    message.error(error instanceof Error ? error.message : '保存失败');
    return Promise.reject();
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "编辑",
    width: 990,
    "confirm-loading": submitting.value,
    "mask-closable": false,
    "destroy-on-close": "",
    "wrap-class-name": "edit-risk-dialog-modal",
    "ok-text": "保存",
    "cancel-text": "取消",
    onOk: handleSave,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.record?.corpCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.record?.channel || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.record?.customerCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", {
              class: "info-value",
              title: __props.record?.customerName || '-'
            }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_14)
          ])
        ]),
        _hoisted_15,
        (_unref(dqysEntries).length)
          ? (_openBlock(), _createBlock(_component_a_table, {
              key: 0,
              class: "dqys-table",
              size: "small",
              bordered: "",
              pagination: false,
              columns: _unref(dqysColumns),
              "data-source": _unref(dqysDataSource),
              "table-layout": "fixed"
            }, null, 8, ["columns", "data-source"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无应收合计数据")),
        _createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          layout: "vertical",
          model: form,
          rules: formRules,
          class: "edit-risk-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "风险等级",
              name: "riskLevel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: form.riskLevel,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.riskLevel) = $event)),
                  placeholder: "请选择风险等级",
                  options: riskLevelOptions,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "风险等级原因",
              name: "riskReason"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: form.riskReason,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.riskReason) = $event)),
                  rows: 3,
                  placeholder: "请输入风险等级原因"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "逾期原因及说明",
              name: "riskDesc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: form.riskDesc,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.riskDesc) = $event)),
                  rows: 4,
                  placeholder: "请输入逾期原因及说明"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否起诉客户",
              name: "isProsecute"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: form.isProsecute,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.isProsecute) = $event)),
                  placeholder: "请选择",
                  options: prosecuteOptions,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})